// interface IProps {
// 	error: boolean
// 	retry?: () => void
// 	pasDelay: boolean
// }

import React from 'react'
import Btn from '../buttom/Btn'

interface IProps {
	error?: boolean
	pasDelay?: boolean
	retry?: () => void
	variant?: 'loader-page' | 'loader-btn'
}

export default function LoaderPage(props: IProps): React.ReactElement {
	if (props.error) {
		return (
			<div className='loader-page'>
				<p className='error'> Opa! Ocorreu um erro </p>

				<Btn
					placeholder='Tente novamente'
					height='2.938rem'
					width='12.625rem'
					onClick={props.retry}
				/>
			</div>
		)
	}
	if (props.pasDelay) {
		return (
			<div className={props.variant ?? 'loader-page'}>
				<div className='center'>
					<div className='loader'> </div>
				</div>
			</div>
		)
	}
	return <></>
}
